import { BusinessLine } from '@cemex-core/cmx-api/models/business-lines/business-line';
import {
  OneClickBusinessLinesActionTypes,
  OneClickBusinessLinesActions,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-business-lines.actions';

export interface OneClickBusinnesLinesState {
  loading: boolean;
  businessLinesAvailable: BusinessLine[];
  selected: BusinessLine;
}

export const initialState: OneClickBusinnesLinesState = {
  loading: false,
  businessLinesAvailable: [],
  selected: null,
};

export function reducer(state = initialState, action: OneClickBusinessLinesActions): OneClickBusinnesLinesState {
  switch (action.type) {
    case OneClickBusinessLinesActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as OneClickBusinnesLinesState;
    }
    case OneClickBusinessLinesActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        businessLinesAvailable: action.payload,
      } as OneClickBusinnesLinesState;
    }
    case OneClickBusinessLinesActionTypes.SELECT: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickBusinnesLinesState;
    }
    case OneClickBusinessLinesActionTypes.LOAD_ERROR:
    case OneClickBusinessLinesActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
